import { withContext } from '@tools/wr-catalog-base'
import CategoriesDropdown from './CategoriesDropdown'

export default withContext(CategoriesDropdown)
